import $thousandMask from "@/mixins/thousandMask";
import makeSecure from "@/components/MakeSecure";

export default {
  name: "profit-or-loses-amount-in-table",
  components: { makeSecure },
  mixins: [$thousandMask],
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
